<style>
a {
    font-weight: bold;
}

.comment-holder {
    margin-top: 20px;
}

.type-badge {
    padding: 3px;
    padding-left: 10px;
    padding-right: 10px;
    border-radius: 15px;
    color: white;
    font-size: 12px;
    display: inline-block;
    line-height: 1em;
}

</style>

<script>
    import Comment from './Comment.svelte'
    import * as Common from './Common.js'

    export let comment;
    
</script>

<svelte:head>
    <!-- Primary Meta Tags -->
    <title>{"Comment on " + comment.item_title}</title>
    <meta name="title" content={comment.user_name + "'s Comment on " + comment.item_title}>
    <meta name="description" content={Common.stripHtml(Common.sanitizeContent(comment.content))}>

    <!-- Open Graph / Facebook -->
    <meta property="og:type" content="website">
    <meta property="og:url" content={"https://plantogether.city/comment/" + comment.id}>
    <meta property="og:title" content={comment.user_name + "'s Comment on " + comment.item_title}>
    <meta property="og:description" content={Common.stripHtml(Common.sanitizeContent(comment.content))}>
    <meta property="og:image" content={"API_URL/item-image/" + comment.item_id + ".png"}>

    <!-- Twitter -->
    <meta property="twitter:card" content="summary_large_image">
    <meta property="twitter:url" content={"https://plantogether.city/comment/" + comment.id}>
    <meta property="twitter:title" content={comment.user_name + "'s Comment on " + comment.item_title}>
    <meta property="twitter:description" content={Common.stripHtml(Common.sanitizeContent(comment.content))}>
    <meta property="twitter:image" content={"API_URL/item-image/" + comment.item_id + ".png"}>
</svelte:head>

{#if comment}
<div>
    Comment on
    <div class="type-badge" style={"background-color:" + Common.getItemTypeColorString(comment.item_type) + ";"}>
        {Common.getItemTypeString(comment.item_type)}
    </div>
    <a href={"#/item/" + comment.item_id} class="item-info">{comment.item_title} by {comment.item_username}</a>:
    <div class="comment-holder">
        <Comment commentId={comment.id}></Comment>
    </div>
</div>
{/if}